
export async function autocompleteInit() {
    // const body = document.querySelector("body");
    // const headerSearch = document.querySelector(".header-search");
    // const autoComplete = document.querySelector(".header-search__autocomplete");
    // const siteHeaderSearch = document.getElementById("searchForm");
    // const autoCompleteOptions = {
    //     placement: "bottom",
    //     modifiers: [
    //         {
    //             name: 'preventOverflow',
    //             options: {
    //                 boundary: body,
    //             },
    //         },
    //         {
    //             name: 'offset',
    //             options: {
    //               offset: [0, 0],
    //             },
    //         },
    //     ],
    // }

    // if (autoComplete) {
    //     const {createPopper} = await import('@popperjs/core');
    //     createPopper(headerSearch, autoComplete, autoCompleteOptions);
    // }

    // if (siteHeaderSearch && headerSearch && autoComplete) {
    //     const {createPopper} = await import('@popperjs/core');
    //     siteHeaderSearch.addEventListener('shown.bs.collapse', evt => {
    //         createPopper(headerSearch, autoComplete, autoCompleteOptions);
    //     });
    // }
}

// autocomplete on hover
export function autocompleteHoverInit() {
    // const searchForm = document.getElementById('form-search');
    // const search = document.querySelector('.header-search');
    // const html = document.querySelector('html');
    // const backdrop = document.querySelector('.site__backdrop');
    // const backdropActiveClass = 'site__backdrop--show';

    // searchForm?.addEventListener('click', (e) => {
    //     e.stopPropagation();
    // });

    // search?.addEventListener('click', () => {
    //     search.classList.add('header-search--active');
    //     backdrop?.classList.add(backdropActiveClass);
    // });

    // html?.addEventListener('click', () => {
    //     const search = document.querySelector('.header-search');

    //     if (search) {
    //         search.classList.remove('header-search--active');
    //         backdrop?.classList.remove(backdropActiveClass);
    //     }
    // });

    // const productAlertClose = document.getElementById('js-products-alert-close');
    // if (productAlertClose) {
    //     productAlertClose.addEventListener('click', function () {
    //         const productAlert = document.getElementById('js-products-alert');

    //         const date = new Date();
    //         date.setFullYear(date.getFullYear() + 100);
    //         document.cookie = 'so_products_alert=1; path=/; expires=' + date.toGMTString();
    //         productAlert.classList.add('d-none');
    //     })
    // }
}
